import { gql } from '@apollo/client';

export const INVITE_EMPLOYEES_TO_GROUP = gql`
  mutation USER_SERVICE_inviteEmployeesToGroup(
    $groupId: String!
    $employees: [Map!]!
    $encrypted: Boolean = true
    $inviteType: InviteType = LINK
  ) {
    inviteEmployeesToGroup(groupId: $groupId, employees: $employees, encrypted: $encrypted, inviteType: $inviteType)
  }
`;
